var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCassetteCoverImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11084 27.5472V5.45264H30.6199V27.5472H2.11084Z",
    fill: "#5B4E4C",
    stroke: "#151312",
    strokeWidth: 1.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11084 10.4417H30.6199",
    stroke: "#151312",
    strokeWidth: 1.28
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.609,
    cy: 18.7169,
    r: 3.97583,
    fill: "#151312",
    stroke: "#5B4E4C",
    strokeWidth: 1.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1217,
    cy: 18.7169,
    r: 3.97583,
    fill: "#151312",
    stroke: "#5B4E4C",
    strokeWidth: 1.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCassetteCoverImg);
export default __webpack_public_path__ + "static/media/cassetteCoverImg.7c0de7e045f961bcf821fcc923e48ad5.svg";
export { ForwardRef as ReactComponent };